<template>
  <div class="container">
    <div class="columns reactivate-policies-view--main">
      <div class="column is-8">
        <h1 class="has-text-weight-bold">Policies</h1>
        <h4>Long Grass Policy</h4>
        <p v-for="(paragraph, index) in longGrassPolicy" :key="index">{{ paragraph }}</p>

        <h4>3-cut Minimum</h4>
        <p>
          We're so confident that you'll enjoy our service that, unlike most lawn care companies, we
          don't require you to sign a long term contract. In fact, we only ask that you commit to
          three cuts in order to evaluate the service.
        </p>
        <p>
          If you're not pleased with the work being done, simply contact us by phone, email, or app,
          and we'll be more than happy to address your concerns.
        </p>

        <h4>48‑hour Reschedule Notice</h4>
        <p>Need to skip a mow? Have to reschedule? No problem!</p>
        <p>
          Go ahead and skip or reschedule a service, for free, with at least 48 hours notice. Any
          less time than that, and you'll be billed for the cost of your normal cut.
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <LsButton
          text="agree &amp; continue"
          track-id="reactivate_policies_view-agree_and_continue"
          class="reactivate-policies-view--agree"
          :disabled="reactivation.loadingStatus.isUpdating"
          @click="agree"
        />
        <LsButton
          text="disagree"
          bg-color="primary-light"
          text-color="primary"
          track-id="reactivate_policies_view-disagree"
          :disabled="reactivation.loadingStatus.isUpdating"
          @click="openCancelOrderModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { LsButton } from '@/components/common';
import { lsModalService, lsRouterHelpers } from 'ls-vue-common';
import { CancelOrderModal } from '@/modals';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'ReactivatePoliciesView',
  components: {
    LsButton,
  },
  data() {
    return {
      property_id: lsRouterHelpers.getParam(this.$route, 'property_id'),
    };
  },
  computed: {
    ...mapState(['reactivation']),
    longGrassPolicy() {
      return lsLongGrassHelpers.getLongGrassPolicy();
    },
  },
  methods: {
    agree() {
      this.$router.replace({
        name: 'propertiesRequiredInfo',
        params: {
          property_id: this.property_id,
        },
      });
    },
    openCancelOrderModal() {
      lsModalService.open({
        parent: this,
        component: CancelOrderModal,
        props: {
          property_id: this.property_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reactivate-policies-view--main {
  h1 {
    margin-bottom: 10px;
  }
  border-bottom: 1px solid $primary-light;
  margin-bottom: 20px;
  h4 {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 25px;
  }
}

.reactivate-policies-view--agree {
  margin-bottom: 10px;
}

@media (min-width: $desktop) {
  .reactivate-policies-view--agree {
    margin-right: 10px;
  }
}
</style>
